// "Tell us who you are" on Suite Home: the owner's own details, asked for until
// they are given. A deliberate skip (after the warning) is remembered only for the
// rest of that DAY, per account AND workspace in this browser: the prompt comes
// back on the next day or sign-in-after-midnight, because an unconfirmed record
// is a standing gap, not a choice made once. The key names both ids, so a value
// written for one account is never honoured for the next one signed into it.
const KEY_PREFIX = 'kb_ownDetailsPromptSkipped';

function key(userId: string, tenantId: string): string {
  return `${KEY_PREFIX}:${userId}:${tenantId}`;
}

// The local calendar day, as YYYY-MM-DD.
function dayOf(now: Date): string {
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
}

export function isOwnDetailsPromptSkippedToday(
  userId: string | null | undefined,
  tenantId: string | null | undefined,
  now: Date = new Date(),
): boolean {
  if (!userId || !tenantId) return false;
  try {
    return window.localStorage.getItem(key(userId, tenantId)) === dayOf(now);
  } catch {
    return false;
  }
}

export function skipOwnDetailsPromptToday(
  userId: string | null | undefined,
  tenantId: string | null | undefined,
  now: Date = new Date(),
): void {
  if (!userId || !tenantId) return;
  try {
    window.localStorage.setItem(key(userId, tenantId), dayOf(now));
  } catch {
    /* storage refused: the prompt simply asks again next time */
  }
}
